export enum Core2Config {
  PG_PRFIX,

  DOMAIN_URL = 'https://api.akaun.com/',
  DOMAIN_TEST_URL = 'https://api-test.akaun.com/',
  DOMAIN_TEST_URL_CORE2 = 'https://api-test.akaun.com/core2/dm/',
  LOCAL_HOST = 'http://localhost:5000/',

  PLATFORM_DOMAIN_URL_PREFIX = 'core2/platform/dm/',

  CUSTOM_CELMONZE_URL_PREFIX = 'cm/celmonze/',
  PLATFORM_URL_PREFIX = 'core2/platform/',
  TENANT_URL_PREFIX = 'core2/tnt/',
  DOMAIN_URL_PREFIX = 'core2/dm/',

  PLATFORM_MICRO_SERVICES_URL_PREFIX = 'core2/platform/ms/',

  ITEM_2_ITEM = 'core2/t2t/dm/',

  TENANT_ECOM_URL_PREFIX = 'core2/tnt/dm/ecom/',
  TENANT_DOMAIN_URL_PREFIX = 'core2/tnt/dm/',
  TENANT_CUSTOM_URL_PREFIX = 'core2/tnt/cm/',
  TENANT_DOMAIN_CRM_MODULE_URL_PREFIX = 'core2/tnt/dm/crm/',
  TENANT_MICRO_SERVICES_CRM_URL_PREFIX = 'core2/tnt/ms/crm/',

  T2T_DOMAIN_URL_PREFIX = 'core2/t2t/dm/',

  DOMAIN_PREFIX = 'dm/',
  MICRO_SERVICES_PREFIX = 'ms/',
  CUSTOM_PREFIX = 'cm/',
  PGW_PREFIX = 'pgw/',
  ERP_PREFIX = 'erp/',
  AAT_PREFIX = 'aat/',
  CLAIMS_PREFIX = 'claims/',
  CONFIG_PREFIX = 'config/',
  CRM_PREFIX = 'crm/',
  DIGI_PREFIX = 'digi/',
  ENGAGEMENT_PREFIX = 'engagements/',
  SENHENG_PREFIX = 'senheng/',
  SENWAVE_PREFIX = 'senwave/',
  UNIPIN_PREFIX = 'unipin/',
  ECOMSYNC_PREFIX = 'ecomsync/',
  CMS_PREFIX = 'cms/',
  DGMKT_MODULE_PREFIX = "dgmkt/",
  INV_PREFIX = "inv/",
  GENERIC_PREFIX = "gen-doc/",
  GENERIC_DOC_PREFIX = "generic-doc/",
  PRINT_PREFIX = "prt/",
  SCH_PREFIX = "sch/",
  WF_PREFIX = 'wf/',
  ALG_CC_MODULE = "alg/cc/",
  UCC_MODULE = "ucc/",
  ALG_BOT_MODULE = "alg/bot/",
  ALG_MODULE = "alg/",
  FM_MODULE = "fm/",
  CONTACT_KEY_PREFIX = "contact-key/",

  IDENTITY_MODULE_PREFIX = "identity/",
  FI_PREFIX = 'fi/',
  APPLET_PREFIX = "applet/",
  COMMISSION_PREFIX = "commission/",
  CPCOMMERCE_PREFIX = 'cp-commerce/',
  MADE_TO_ORDER_PREFIX = "mto/",

  SFA_MODULE_PREFIX = "sfa/",
  SALES_COMMISSION_PREFIX = "sales-commission-report/",
  REPORTS_PREFIX = "reports/",

  DATALIB_PREFIX = "datalib/",

  RECURRING_PREFIX = "recurring-docs/",
  TEMPLATES_PREFIX = "templates/",
  TPY_PREFIX = 'tpy/',
  INNOVATIF_EKYC_PREFIX = "innovatif-ekyc/",
  WARRANTY_PREFIX = "wrty/",
  BACKOFFICE_EP_SUFFIX = "backoffice-ep",
  LOGIN_ENTITY_EP_SUFFIX = "login-entity-ep",
  LOGIN_EP_SUFFIX = "login-ep",
  MKP_PREFIX = "mkp/",
  MLM_PREFIX = "mlm/",
  HR_PREFIX = "hr/",
  HEALTHCARE_PREFIX = "hc/",
  MRP_PREFIX = "mrp/",
  DEL_PREFIX = "del/",
  STATEMENT_OF_ACCOUNT_PREFIX = "statement-of-account/",
  PUBLIC_EP_SUFFIX = "public-ep",
  E_INVOICE_PREFIX = 'e-invoice/',
  PEPPOL_PREFIX = 'ppl/',
  ASV_PREFIX = 'asv/',
  EXTERNAL_PREFIX = 'xtn/',
  ORGANISATION_PREFIX = 'organisation/',
  IAM_PREFIX = 'iam/',
  LOGIN_CONSOLIDATED_ARAP_EP_SUFFIX = 'login-consolidated-arap-ep',
}

